<template>
    <div>
        <Charts :option="option" />
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, watch } from 'vue';
import Charts from "@/components/Charts";

const props = defineProps<{ value: number, min: number, max: number }>();

onMounted(() => {
    // 监听 props.value 的变化
    watch(() => props.value, (newValue) => {
        console.log("[ZJL]🚀 ~ watch ~ newValue:", newValue);
    });

    // 监听 props.min 的变化
    watch(() => props.min, (newValue) => {
        console.log("[ZJL]🚀 ~ watch ~ newMin:", newValue);
    });

    // 监听 props.max 的变化
    watch(() => props.max, (newValue) => {
        console.log("[ZJL]🚀 ~ watch ~ newMax:", newValue);
    });
});


// 导出默认的图表配置
const option = computed(() => {
    // 修正 SVG 路径
    let list = [
        {
            name: "方向盘角度",
            value: props.value,
        },
    ]

    // 柱状图的宽度
    let barWidth = 20;

    // 计算最大值和最小值
    const maxValue = props.max;
    const minValue = props.min;
    return {
        animation: false,
        // 背景色设置为透明
        backgroundColor: "rgba(0,0,0,0.0)",
        // Y 轴配置
        yAxis: {
            // 设置最小值和最大值
            min: minValue,
            max: maxValue,
            // 不显示分割线
            splitLine: {
                show: false,
            },
            // 不显示轴标签
            axisLabel: {
                show: false,
            },
            // 不显示轴刻度
            axisTick: {
                show: false,
            },
            // 不显示轴线
            axisLine: {
                show: false,
            },
        },

        // 网格配置
        grid: {
            // 包含标签
            containLabel: true,
            // 左边距
            left: 0,
            // 顶边距
            top: 0,
            // 右边距设置为 0，去除右侧竖线
            right: 0,
            // 底边距
            bottom: 0,
        },

        // X 轴配置
        xAxis: [
            {
                // X 轴反转
                inverse: true,
                // 不显示轴线
                axisLine: {
                    show: false,
                },
                // 不显示轴刻度
                axisTick: {
                    show: false,
                },
                splitLine: { show: false },
                // 轴标签配置
                axisLabel: {
                    show: false,
                },
                // X 轴数据
                data: list.map(item => item.name),
            },
        ],

        // 系列配置
        series: [
            {
                // 内部柱状图
                type: "bar",
                barWidth,
                // 不响应图例的鼠标事件
                legendHoverLink: false,
                // 符号重复
                symbolRepeat: true,
                // 不响应鼠标事件
                silent: true,
                // 柱状图样式
                itemStyle: {
                    color: {
                        type: "linear",
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            {
                                offset: 1,
                                color: "#FFF68F", // 0% 处的颜色
                            },
                            {
                                offset: 0,
                                color: "#EE2C2C", // 100% 处的颜色
                            },
                        ],
                    },
                },
                // 数据
                data: list.map(item => item.value),
                // 层级
                z: 1,
                // 动画效果
                animationEasing: "elasticOut",
            },
            {
                // 背景象形柱图
                type: "pictorialBar",
                // 动画持续时间为 0
                animationDuration: 0,
                // 符号重复固定
                symbolRepeat: "fixed",
                // 符号间距
                symbolMargin: "20%",
                // 符号形状
                symbol: "roundRect",
                // 符号大小
                symbolSize: [barWidth, 6],
                // 样式
                itemStyle: {
                    normal: {
                        color: "#CDC9C9",
                    },
                },
                // 标签配置
                label: {
                    normal: {
                        show: true,
                        position: "top",
                        offset: [0, 2],
                        distance: 30,
                    },
                },
                // 数据
                data: "1",
                // 层级
                z: 0,
                // 动画效果
                animationEasing: "elasticOut",
            },
            {
                // 分隔象形柱图
                type: "pictorialBar",
                // 样式
                itemStyle: {
                    color: "#000",
                },
                // 符号重复固定
                symbolRepeat: "fixed",
                // 符号间距
                symbolMargin: 4,
                // 符号形状
                symbol: "roundRect",
                // 符号裁剪
                symbolClip: true,
                // 符号大小
                symbolSize: [barWidth, 2],
                // 符号位置
                symbolPosition: "start",
                // 符号偏移
                symbolOffset: [0, 0],
                // 数据
                data: list.map(item => item.value),
                // 层级
                z: 2,
                // 动画效果
                animationEasing: "elasticOut",
                // 标签配置
                label: {
                    normal: {
                        show: true,
                        position: "top",
                        offset: [0, 2],
                        distance: 30,
                    },
                },
            },
        ],
    }
});
</script>